import * as Monaco from 'monaco-editor/esm/vs/editor/editor.api';

const light = {
  iriBase: '#e22e00',
  iriLocal: '#000000',
  comment: '#b1b1b1',
  sugar: '#1400ff',
  operator: '#639c45',
  modifier: '#7123d2',
  question: '#00b1bd',
  invalid: '#0033ff',
};

export const EDITOR_THEME_ID = 'stardog';

export const EDITOR_THEME: Monaco.editor.IStandaloneThemeData = {
  base: 'vs',
  inherit: true,
  rules: [
    {
      token: 'keyword',
      foreground: light.sugar,
    },
    {
      token: 'keyword.modifier',
      foreground: light.modifier,
    },
    {
      token: 'keyword.builtin',
      foreground: light.modifier,
    },
    {
      token: 'identifier.langtag',
      foreground: light.iriLocal,
    },
    {
      token: 'operators',
      foreground: light.operator,
    },
    {
      token: 'identifier.iri',
      foreground: light.iriLocal,
    },
    {
      token: 'identifier.iri.prefix',
      foreground: light.iriBase,
    },
    {
      token: 'variable',
      foreground: light.question,
    },
    {
      token: 'comment',
      foreground: light.comment,
    },
    {
      token: 'invalid',
      foreground: light.invalid,
    },
  ],
  colors: {},
};
